import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('admin');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
  updateDetails: (data) => api.put('/auth/updatedetails', data),
  updatePassword: (data) => api.put('/auth/updatepassword', data)
};

// Laptop API
export const laptopAPI = {
  getAll: (params) => api.get('/laptops', { params }),
  getById: (id) => api.get(`/laptops/${id}`),
  getBySerial: (serialNumber) => api.get(`/laptops/serial/${serialNumber}`),
  create: (data) => api.post('/laptops', data),
  update: (id, data) => api.put(`/laptops/${id}`, data),
  delete: (id) => api.delete(`/laptops/${id}`),
  getStats: () => api.get('/laptops/stats/summary'),
  regenerateQRCode: (id) => api.post(`/laptops/${id}/qrcode`)
};

// History API
export const historyAPI = {
  getAll: (params) => api.get('/history', { params }),
  getLaptopHistory: (laptopId) => api.get(`/history/laptop/${laptopId}`),
  getBySerial: (serialNumber) => api.get(`/history/serial/${serialNumber}`),
  getStats: (params) => api.get('/history/stats/summary', { params })
};

// Repair API
export const repairAPI = {
  getAll: (params) => api.get('/repairs', { params }),
  getById: (id) => api.get(`/repairs/${id}`),
  getLaptopRepairs: (laptopId) => api.get(`/repairs/laptop/${laptopId}`),
  getBySerial: (serialNumber) => api.get(`/repairs/serial/${serialNumber}`),
  create: (data) => api.post('/repairs', data),
  update: (id, data) => api.put(`/repairs/${id}`, data),
  delete: (id) => api.delete(`/repairs/${id}`),
  getStats: (params) => api.get('/repairs/stats/summary', { params })
};

export default api;
